export const GET_MY_PAYMENTS_SUCCESS = 'GET_MY_PAYMENTS_SUCCESS'
export const GET_MY_PAYMENTS_FAIL = 'GET_MY_PAYMENTS_FAIL'